import {
    useEffect,
} from 'react'

import {
    ChatwootAppUser,
} from './types'

const useChatwootUser = (user: ChatwootAppUser | null): void => {
    const userKey = user ? JSON.stringify(user) : null

    useEffect(() => {
        const applyUser = (): void => {
            if (!window.$chatwoot) {
                return
            }

            if (user) {
                window.$chatwoot.setUser(user.email, {
                    email: user.email,
                })

                if (user.gatewayMac) {
                    window.$chatwoot.setCustomAttributes({
                        gatewayMac: user.gatewayMac,
                    })
                }
            } else {
                window.$chatwoot.reset()
            }
        }

        if (window.$chatwoot?.hasLoaded) {
            applyUser()
            return undefined
        }

        window.addEventListener('chatwoot:ready', applyUser)
        return () => {
            window.removeEventListener('chatwoot:ready', applyUser)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userKey])
}

export default useChatwootUser
